module.exports = __webpack_public_path__ + "assets/img/jp_17.75564372.jpg";